const codesWithAffirm = ['US', 'PR', 'UM', 'GU', 'VI', 'AS', 'MP'];

export const isLocationAvailableWithAffirm = resortLocation => {
  return resortLocation !== 'NIAGON';
};

export const isAffirmAvailable = country => {
  return codesWithAffirm.includes(country);
};
